<template>
  <div class="w w1200">
    <!-- 面包屑导航 -->
    <el-breadcrumb class="breakcrumbHeader" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商家入驻申请</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row :gutter="20">
      <el-col :span="6">
        <div class="aside">
          <h4 class="aside-title">商家入驻指南</h4>
          <ul class="aside-list">
            <li class="aside-item">签订入驻协议</li>
            <li class="aside-item active">填写商家资料</li>
            <li class="aside-item">平台审核</li>
            <li class="aside-item">合同签订及缴费</li>
            <li class="aside-item">店铺开通</li>
          </ul>
        </div>
        <div class="aside">
          <h4 class="aside-title">平台联系方式</h4>
          <ul class="aside-list">
            <li class="aside-item">电话：400-0456880</li>
            <li class="aside-item">邮箱：18748424242@163.com</li>
          </ul>
        </div>
      </el-col>
      <el-col :span="18">
        <div class="rightaside">
          <h3><strong>提示</strong>: 信息提交过后不可进行修改，请慎重填写！</h3>
          <el-form :model="sizeForm" :rules="rules" ref="sizeForm" label-width="150px" class="nextPart">
            <el-card shadow="never" header="公司信息">
              <el-form-item label="企业全称" prop="companyName">
                <el-input v-model="sizeForm.companyName" placeholder="企业全称"></el-input>
              </el-form-item>
              <el-form-item label="公司所在地" prop="companyLocation">
                <el-cascader ref="address" placeholder="公司所在地" :props="{ checkStrictly: true }"
                             :options="getprovince" @change="areaHandleChange">
                </el-cascader>
                <span class="picked-address">{{sizeForm.companyLocationName}}</span>
              </el-form-item>
              <el-form-item label="地址" prop="address">
                <el-input v-model="sizeForm.address" placeholder="请输入公司详细地址"></el-input>
              </el-form-item>
              <!--            <el-form-item label="邮编" prop="postalCode">-->
              <!--              <el-input  v-model="sizeForm.postalCode" placeholder="请输入公司邮编"></el-input>-->
              <!--            </el-form-item>-->
              <el-form-item label="电话" prop="phone">
                <el-input maxlength="11" v-model="sizeForm.phone" placeholder="请输入公司电话"></el-input>
              </el-form-item>
              <!--            <el-form-item label="公司网址" prop="companyUrl">-->
              <!--              <el-input  v-model="sizeForm.companyUrl" placeholder="请输入公司网址"></el-input>-->
              <!--            </el-form-item>-->
              <!--            <el-form-item label="公司介绍" prop="companyProfile">-->
              <!--              <el-input  v-model="sizeForm.companyProfile" placeholder="请输入公司介绍"></el-input>-->
              <!--            </el-form-item>-->
              <el-form-item label="联系人" prop="contactPerson">
                <el-input v-model="sizeForm.contactPerson" placeholder="联系人"></el-input>
              </el-form-item>
              <!--            <el-form-item label="职位" prop="position">-->
              <!--              <el-input  v-model="sizeForm.position" placeholder="职位"></el-input>-->
              <!--            </el-form-item>-->
              <el-form-item label="联系人电话" prop="emergencyManCall">
                <el-input maxlength="11" v-model="sizeForm.emergencyManCall" placeholder="联系人电话"></el-input>
              </el-form-item>
              <el-form-item label="联系人邮箱" prop="emergencyManEmail">
                <el-input v-model="sizeForm.emergencyManEmail" placeholder="联系人邮箱"></el-input>
              </el-form-item>
              <el-form-item label="推荐人" prop="recommendUserPhone">
                <el-input maxlength="11" v-model="sizeForm.recommendUserPhone" placeholder="推荐人手机号"></el-input>
              </el-form-item>
              <!--            <el-form-item label="注册资金" prop="registeredCapital">-->
              <!--              <el-input  v-model="sizeForm.registeredCapital" placeholder="注册资金"></el-input>-->
              <!--            </el-form-item>-->
              <!--            <el-form-item label="员工总数" prop="staffNum">-->
              <!--              <el-input  v-model="sizeForm.staffNum" placeholder="员工总数"></el-input>-->
              <!--            </el-form-item>-->
              <el-form-item label="纳税人识别号" prop="taxpayerNumber">
                <el-input v-model="sizeForm.taxpayerNumber" placeholder="纳税人识别号"></el-input>
              </el-form-item>
              <el-form-item label="发票抬头" prop="invoice">
                <el-input v-model="sizeForm.invoice" placeholder="发票抬头"></el-input>
              </el-form-item>
              <el-form-item label="营业执照" prop="businessLicense">
                <el-upload
                  name="files"
                  class="avatar-uploader"
                  :action="`${$baseUrl}/custom/xunyou/api/common/upload`"
                  :show-file-list="false"
                  :on-success="(e, file) => handleAvatarSuccess(e, file, 'businessLicense')"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="sizeForm.businessLicense" :src="sizeForm.businessLicense" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="辅助材料">
                <el-upload
                  name="files"
                  multiple
                  :limit="6"
                  class="avatar-uploader"
                  :action="`${$baseUrl}/custom/xunyou/api/common/upload`"
                  :file-list="imgList"
                  list-type="picture"
                  :on-success="(e, file) => handleAvatarSuccess(e, file, 'extImg')"
                  :on-remove="extImgRemove"
                  :on-exceed="handleExceed"
                  :before-upload="beforeAvatarUpload">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>
            </el-card>

            <el-card shadow="never" header="店铺信息">
              <el-form-item label="店铺logo" prop="logo">
                <el-upload
                  name="files"
                  class="avatar-uploader"
                  :action="`${$baseUrl}/custom/xunyou/api/common/upload`"
                  :show-file-list="false"
                  :on-success="(e, file) => handleAvatarSuccess(e, file, 'logo')"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="sizeForm.logo" :src="sizeForm.logo" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="店铺名称" prop="name">
                <el-input v-model="sizeForm.name" placeholder="店铺名称"></el-input>
              </el-form-item>
              <el-form-item label="店铺等级" prop="level">
                <el-select v-model="sizeForm.level" placeholder="请选择店铺等级">
                  <el-option v-for="item in levelList" :key="item.bxslId"
                             :label="`${item.name} 费用:${item.standard} 描述:普通店铺，年费${item.standard}元`"
                             :value="item.bxslId"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="店铺分类" prop="sort">
                <el-select v-model="sizeForm.sort" placeholder="请选择店铺分类" @change="getShopid">
                  <el-option
                    v-for="item in storeClasslists" :key="item.bxscId"
                    :label="item.name" :value="item.bxscId">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="经营类目" prop="mainproduct">
                <el-tree
                  ref="tree"
                  :data="leftmenus"
                  show-checkbox
                  node-key="value"
                  @check-change="getCheckedNodes"
                  :props="props">
                </el-tree>
              </el-form-item>
            </el-card>
          </el-form>
          <div class="btn-box">
            <el-button type="primary" :loading="loading" @click="submitApply('ruleForm')">提交申请</el-button>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {merchantForm, merchantReApply, refreshUser, slevelList, leftmenu, storeClassList} from '../../api/xunyou'
import {mapState, mapMutations} from 'vuex'

export default {
  data() {
    return {
      loading: false,
      provincevalue: [],
      props: {multiple: true}, // 联级选择
      bxscId: "",
      imgList: [],
      sizeForm: {
        type: 2, // 入驻类型 1:供应商，2：商家
        businessLicense: '',
        companyName: "",
        companyLocation: '',
        companyLocationName: '',
        address: '',
        postalCode: '',
        phone: '',
        companyUrl: '',
        companyProfile: '默认值',
        contactPerson: '',
        position: '默认值',
        emergencyManCall: '',
        recommendUserPhone: '',
        emergencyManEmail: '',
        registeredCapital: '1000000',
        staffNum: '10',
        taxpayerNumber: '',
        invoice: '',
        extImg: [],
        // 店铺信息
        logo: '',
        name: '',
        level: '',
        sort: '',
        mainproduct: '',
        sellerAccount: this.$store.state.userInfo.loginName
      },
      levelList: [], //店铺登记
      storeClasslists: [], //商品分类
      leftmenus: [], // 店铺类目
      showTree: false,
      defaultProps: {
        children: 'subItems',
        label: 'name'
      },
      // getprovince:[],
      rules: {
        companyName: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],
        companyLocation: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],
        address: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],
        postalCode: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],//{ type: 'number', message: '必须为数字值'}
        phone: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],//{ type: 'number', message: '必须为数字值'}
        companyUrl: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],
        companyProfile: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],
        contactPerson: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],
        position: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],
        emergencyManCall: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],//{ type: 'number', message: '必须为数字值'}
        emergencyManEmail: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]}, {
          type: 'email',
          message: '请输入正确的邮箱地址',
          trigger: ['blur', 'change']
        }],
        registeredCapital: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],
        staffNum: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],//{ type: 'number', message: '必须为数字值'}
        // taxpayerNumber: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],
        // invoice: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],
        businessLicense: [{required: true, message: "不能为空,请上传营业执照", trigger: ["blur", "change"]},],
        // 店铺信息
        logo: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],
        name: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],
        level: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],
        sort: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],
        mainproduct: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],
        // sellerAccount:[{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
      },
    };
  },
  computed: {
    ...mapState(['getprovince', 'applyStoreData']),
    isReApply () {
      return this.$route.query.type && this.$route.query.type === 'edit'
    }
  },
  created() {
    this.slevelLists()
    this.getstoreClasslists()
    this.getleftmenus()
    if (this.isReApply) {
      this.editAgain();
    }
  },
  methods: {
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 6 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    extImgRemove (file, fileList) {
      console.log(file)
      const index = this.sizeForm.extImg.findIndex(url => {
        const oUrl = file.response ? file.response.url : file.url;
        return oUrl === url;
      });
      this.sizeForm.extImg.splice(index, 1);
    },
    // 重新编辑
    editAgain () {
      this.type = this.applyStoreData.merchant.type;
      this.sizeForm.companyName = this.applyStoreData.merchant.companyName;
      this.sizeForm.companyLocation = this.applyStoreData.merchant.companyLocation;
      this.sizeForm.companyLocationName = this.applyStoreData.merchant.companyLocationName;
      this.sizeForm.address = this.applyStoreData.merchant.address;
      this.sizeForm.postalCode = this.applyStoreData.merchant.postalCode;
      this.sizeForm.phone = this.applyStoreData.merchant.phone;
      this.sizeForm.companyUrl = this.applyStoreData.merchant.companyUrl;
      this.sizeForm.contactPerson = this.applyStoreData.merchant.contactPerson;
      this.sizeForm.position = this.applyStoreData.merchant.position;
      this.sizeForm.emergencyManCall = this.applyStoreData.merchant.emergencyManCall;
      this.sizeForm.recommendUserPhone = this.applyStoreData.merchant.recommendUserPhone;
      this.sizeForm.emergencyManEmail = this.applyStoreData.merchant.emergencyManEmail;
      this.sizeForm.registeredCapital = this.applyStoreData.merchant.registeredCapital;
      this.sizeForm.staffNum = this.applyStoreData.merchant.staffNum;
      this.sizeForm.taxpayerNumber = this.applyStoreData.merchant.taxpayerNumber;
      this.sizeForm.invoice = this.applyStoreData.merchant.invoice;
      this.sizeForm.businessLicense = this.applyStoreData.merchant.businessLicense;
      this.sizeForm.logo = this.applyStoreData.merchant.logo;
      this.sizeForm.name = this.applyStoreData.merchant.name;
      this.sizeForm.level = this.applyStoreData.merchant.level;
      this.sizeForm.levelName = this.applyStoreData.levelName;
      this.sizeForm.sort = this.applyStoreData.merchant.sort;
      this.sizeForm.mainproduct = this.applyStoreData.merchant.mainproduct;
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys(this.applyStoreData.merchant.mainproduct.split(','));
      });
      if (this.applyStoreData.merchant.extImg) {
        this.sizeForm.extImg = this.applyStoreData.merchant.extImg.split(',');
        this.imgList = this.sizeForm.extImg.map((url, index) => ({
          name: index,
          url: url
        }));
      }
    },
    //获取店铺id
    getShopid(id) {
      this.bxscId = id
      localStorage.setItem('bxscId', this.bxscId)
    },
    // 地址选择
    areaHandleChange(value) {
      console.log('选择的地址：', value);
      if (value.length !== 0) {
        let arr = this.$refs['address'].getCheckedNodes()[0].pathLabels;
        console.log('arr', arr)
        this.sizeForm.companyLocation = value[value.length - 1];
        this.sizeForm.companyLocationName = arr.join('/');
      }
    },
    // 经营类目获取选中的节点
    getCheckedNodes() {
      let nodesObj = this.$refs.tree.getCheckedNodes(false, true);
      const codes = nodesObj.map(ele => ele.value);
      if (codes[codes.length - 1] === 0) {
        codes.splice(codes.length - 1, 1); // 最后一位如果为0，删除掉
      }
      this.sizeForm.mainproduct = codes.join(',');
    },

    // 店铺等级
    slevelLists() {
      slevelList().then(res => {
        if (res.code == 0) {
          this.levelList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      }).catch(err => {
        this.$message.error('提交失败，请稍后再试！')
      })
    },
    // 店铺分类
    getstoreClasslists() {
      storeClassList().then(res => {
        if (res.code === 0) {
          this.storeClasslists = res.data;
        } else {
          this.$message.error(res.msg);
        }
      }).catch(err => {
        this.$message.error('提交失败，请稍后再试！')
      })
    },
    // 店铺类目
    getleftmenus() {
      leftmenu().then(res => {
        if (res.code == 0) {
          this.leftmenus = res.data;
        } else {
          this.$message.error(res.msg);
        }
      }).catch(err => {
        this.$message.error('提交失败，请稍后再试！');
      })
    },

    submitApply() {
      this.$refs.sizeForm.validate((valid) => {
        if (valid) {
          const params = JSON.parse(JSON.stringify(this.sizeForm));
          params.extImg = this.sizeForm.extImg.join(',');
          let _promise = null;
          this.loading = true;
          if (this.isReApply) {
            _promise = merchantReApply(params);
          } else {
            _promise = merchantForm(params);
          }
          _promise.then(res => {
              this.loading = false;
              if (res.code === 0) {
                this.$router.replace('/settleIn/merchantStatus');
                this.$store.dispatch('getStoreData');
                this.refreshUserInfo();
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch(err => {
              this.$message.error('提交失败，请稍后再试！')
            })
        }
      });
    },
    refreshUserInfo() {
      refreshUser({
        username: this.$store.state.userInfo.loginName
      }).then(res => {
        if (res.code != 0) {
          this.$message.error(res.msg);
        } else {
          console.log("刷新本地用户信息：", res.data);
          this.$store.commit('login', res.data);
        }
      });
    },
    handleAvatarSuccess(res, file, key) {
      console.log('上传结果：', res);
      if (key === 'extImg') {
        this.sizeForm[key].push(res.url);
      } else {
        this.sizeForm[key] = res.url;
      }
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    }
  }
};
</script>

<style scoped lang="less">
.breakcrumbHeader {
  margin: 15px 0;
}
/deep/ .el-card__header{
  padding: 10px 20px;
  font-size: 18px;
  font-weight: 500;
}
.aside {
  box-sizing: border-box;
  font-size: 14px;
  margin-right: 10px;
  margin-bottom: 40px;
  background-color: #fff;

  .aside-title {
    padding: 10px;
    border-bottom: 1px solid #ddd;
    font-size: 16px;
    font-weight: 700;
  }

  .aside-item {
    padding: 10px;

    &.active {
      color: var(--main-theme-color);
    }
  }
}

.rightaside {
  h3 {
    font-size: 14px;
    color: #333;
    background: #fcf8e3;
    padding: 14px;
    border: 1px solid #faebcc;
    border-radius: 4px;
  }

  /deep/ .el-card {
    margin-top: 10px;
  }

  /deep/ .el-upload.el-upload--text {
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
  }

  .avatar {
    width: 160px;
    height: 160px;
    display: block;
  }

  .btn-box {
    padding: 15px;
    background-color: #fff;
    text-align: center;
  }
}
</style>







// WEBPACK FOOTER //
// src/views/merchantSettled/merchantForm.vue